module.exports = __webpack_public_path__ + "static/media/edit.e3cedb0b.svg";